export default "__VITE_ASSET__f94739fc__"